<template>
    <p-search-screen
        title="Product Variant Groups"
        api-destination="productvariantgroup"
        edit-key="productVariantGroupId"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        :show-set-to="false"
        :use-is-active-checkbox="false"
        add-new-button
    >
        <template v-slot:belowSearch>
            <b-row>
                <b-col>
                <p-checkbox
                    label="Active"
                    v-model="filters.active"
                />
                <p-checkbox
                    label="Inactive"
                    class="ms-2"
                    v-model="filters.inactive"
                />
                </b-col>
            </b-row>
        </template>
    </p-search-screen>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'ProductVariantGroupFilter',
            isBusy: false,
            selectedWeborders: [],
            filters: {
                automatic: '',
                perPage: 100,
                sortBy: 'groupName',
                sortDesc: true,
                active: true,
                inactive: false,
                searchBy: 'All'
            },
            filterBy: ['All', 'Group Name', 'Group Description'],
            fields: [
                {
                    key: 'groupName',
                    sortable: true,
                    label: 'Group Name'
                },
                {
                    key: 'description',
                    sortable: true,
                    label: 'Group Description'
                },
                {
                    key: 'status',
                    label: 'Status'
                }
            ]
        };
    },
    methods: {}
};
</script>
